import { useQuery } from '@apollo/client';

import { EventProduct, getUpcomingCateringEventDetails } from '@/api';

import { CateringEventVendorDetailsUpcoming } from '../types';
import { parseEventVendorIds } from '../helpers';

type UseCateringUpcomingEvent = {
  event: CateringEventVendorDetailsUpcoming | undefined;
  loading: boolean;
};

// The route param can carry several ids for aggregated delivery cards, so the
// query takes a list. CATERING events are not aggregated, hence the first result.
export const useCateringUpcomingEvent = (id: string): UseCateringUpcomingEvent => {
  const { data, loading } = useQuery(getUpcomingCateringEventDetails, {
    variables: { input: { eventVendorIds: parseEventVendorIds(id), productType: EventProduct.CATERING } },
  });

  return {
    event: data?.getEventVendors?.eventVendors?.[0] as CateringEventVendorDetailsUpcoming | undefined,
    loading,
  };
};
